module.exports = __webpack_public_path__ + "static/img/33.ceba502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/33.png
// module id = vvNJ
// module chunks = 1